import React, {createContext, ReactNode, useState} from 'react';

import {getDefaultRecordsSort} from '/util/sort.util';

export const RecordsSortContext = createContext<any>(undefined);

type RecordsSortContextProviderProps = {
  children: ReactNode;
};

export function RecordsSortContextProvider({
  children = null,
}: RecordsSortContextProviderProps) {
  const [sortParams, setSelectedSortParams] = useState({});
  const [isViewTeam, setIsViewTeam] = useState(false);
  const [activeRecordsName, setActiveRecordsName] = useState<
    string | undefined
  >(undefined);

  const setInitialSortParams = ({recordsName}: any) => {
    const updatedSortParams = {
      ...sortParams,
      [recordsName]: getDefaultRecordsSort({recordsName}),
    };
    setSelectedSortParams(updatedSortParams);
  };

  const setSelectedSortParam = ({recordsName, sortParam}: any) => {
    const updatedSortParams = {
      ...sortParams,
      [recordsName]: sortParam,
    };
    setSelectedSortParams(updatedSortParams);
  };

  const resetSortParams = ({recordsName}: any) => {
    const updatedSortParams = {
      ...sortParams,
      [recordsName]: getDefaultRecordsSort({recordsName}),
    };
    setSelectedSortParams(updatedSortParams);
  };

  return (
    <RecordsSortContext.Provider
      value={{
        sortParams,
        setSelectedSortParam,
        setInitialSortParams,
        resetSortParams,
        isViewTeam,
        setIsViewTeam,
        activeRecordsName,
        setActiveRecordsName,
      }}>
      {children}
    </RecordsSortContext.Provider>
  );
}
